import FileViewer from 'react-file-viewer';
import { useEffect, useRef } from 'react';

function DocumentFileViewer({ fileUrl, fileType }) {
  const containerRef = useRef(null);
  const viewerRef = useRef(null);

  const onError = (e) => {
    console.log('Error loading file:', e);
  };

  useEffect(() => {
    // 在组件加载后调整内部元素的宽度
    const adjustWidth = () => {
      if (viewerRef.current && containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const innerElements = viewerRef.current.querySelectorAll('*');
        
        innerElements.forEach(element => {
          // 重置所有可能影响宽度的样式
          element.style.maxWidth = 'none';
          element.style.width = '100%';
          
          // 特别处理常见的文档查看器元素
          if (element.tagName === 'IFRAME' || element.tagName === 'EMBED') {
            element.style.width = '100%';
            element.style.minWidth = '100%';
            element.style.maxWidth = '100%';
          }
          
          if (element.classList.contains('pdf-viewer') || 
              element.classList.contains('office-viewer')) {
            element.style.width = '100%';
            element.style.minWidth = '100%';
          }
        });
      }
    };

    // 初始调整
    adjustWidth();

    // 添加延迟调整，确保内容加载完成
    const timer = setTimeout(adjustWidth, 500);

    return () => clearTimeout(timer);
  }, [fileUrl]);

  const containerStyle = {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f5f5f5'
  };

  const wrapperStyle = {
    flex: 1,
    overflow: 'auto',
    padding: '20px',
    backgroundColor: 'white',
    margin: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    width: 'calc(100% - 40px)' // 确保包装器宽度正确
  };

  const viewerStyle = {
    width: '100%',
    minWidth: '100%',
    maxWidth: '100%',
    padding: '10px',
  };

  return (
    <div style={containerStyle} ref={containerRef}>
      <div style={wrapperStyle}>
        <div ref={viewerRef} style={viewerStyle}>
          <FileViewer
            fileType={fileType}
            filePath={fileUrl}
            onError={onError}
            errorComponent={<div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>无法加载文档</div>}
            unsupportedComponent={<div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>不支持的文件格式</div>}
          />
        </div>
      </div>
    </div>
  );
}

export default DocumentFileViewer;